export enum S1UserRole {
    USER = 1,
    SYSTEM_ADMIN = 2,
    MANAGER = 5,
    SECURITY_ADMIN = 6
}